import { AfterContentInit, AfterViewInit, Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { GlobalService } from './service/global.service';
import { HeaderV01H00C00Component } from './shared/header-v01-h00-c00/header-v01-h00-c00.component';
import { DOCUMENT } from '@angular/common';
import { FooterV01H00C00Component } from './shared/footer-v01-h00-c00/footer-v01-h00-c00.component';
import { IAMServiceService } from './service/iamservice.service';
import { SessionModel } from './interface/session-model';
import { Location } from '@angular/common';
import { DatasharingService } from './service/datasharing.service';
import { URLEnum } from './url-enum';
import { AppconfigService } from './service/appconfig.service';
import { EventTargetInterruptSource, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'angular_base_file';

  currentNavigation: string = '';

  idleState = 'NOT_STARTED';
 timedOut = false;


  @ViewChild(HeaderV01H00C00Component) headerComp!: HeaderV01H00C00Component;
  @ViewChild(FooterV01H00C00Component) footerComp!: FooterV01H00C00Component;
  sessionList: SessionModel = new SessionModel();
  sessionTimeout: any;
  idleSessionStart: any;
  queryParams: any;
  renderMainContent: boolean = false;

  authType = this.configService.config.Authentication;
  
  constructor(public router: Router, activeRoute: ActivatedRoute, public service: GlobalService, @Inject(DOCUMENT) private document: Document, private IAMServiceService: IAMServiceService,
    private location: Location, private datasharing: DatasharingService, private configService: AppconfigService,
    private idle: Idle,private elementRef: ElementRef, private globeService: GlobalService,
    private keepalive: Keepalive,  private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) platformId: Object) {

    console.log('app comp const');
    this.checkMainContentRendering();
    this.sessionTimeout = this.configService.config.sessionTimeOut;
    this.idleSessionStart = this.configService.config.idleSessionStart;


    //check if browser refresh.. If refresh, get the selectedRole from session and push into datasharing obj
    router.events.subscribe((event) => {
      
      if (event instanceof NavigationEnd) {

        let currentroute = this.router.url;
        if (currentroute == '/client/login' || currentroute == '/client/signin' || 
          currentroute == "" || currentroute == undefined || currentroute == null || currentroute == '/' ||
           currentroute.includes('/client/passwordmanage')) {
          this.currentNavigation = 'login'
        }
        else {
          this.currentNavigation = currentroute;
        }
        //Check page refresh. And refresh accordingly
        this.checkPageRefresh(event.url, platformId);
      }
    })

    //Start watching for session timeout
    this.startWatching();

  }

  checkPageRefresh(currentUrl: any, platformId: any)
  {
    console.log('checkPageRefresh')
    //if user is already logged in, redirect to home screen and reload 
    // If user is not logged in yet, redirect to login page
    if(currentUrl.includes('/ssoauth/appredirect') || currentUrl.includes('/error'))
    {
      console.log('if of checkPageRefresh')  
    }
    else 
    {
      if (isPlatformBrowser(platformId)) {
          const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
          const type = navEntries?.[0]?.type; // 'navigate' | 'reload' | 'back_forward' | 'prerender'
          
          if(currentUrl.includes('home/list')){
            this.datasharing.isPowerBiB.next(false);
          }
          
          if (type === 'reload' ){//|| currentUrl.includes('home/list') ) {
            console.log('Detected browser refresh');
             this.datasharing.isPageRefreshB.next(true);
             //this.datasharing.refreshUrlB.next(event.url);
             console.log(currentUrl)
             console.log(currentUrl)
             console.log(currentUrl)
             console.log(currentUrl)
              if(
                ((currentUrl.includes('home/list') 
                || currentUrl.includes('change-password') )
                && !currentUrl.includes('ssoauth')
                && !currentUrl.includes('home/listDetail')  )	     
              )
              {
                console.log('success scenario for reload. Reload userprofile')
                // Reload user profile data if user is already logged in
                // and redirect based on current screen route
                this.service.reloadUserProfileAndRoles();
              }      
          }
        }
      
    }
  }

 
  
  public wait(ms: any) {
    var start = new Date().getTime();
    var end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  }

  ngOnInit(): void {

    //console.log('Inside app comp init');
    
    this.startWatching();
    this.getScrlDirection();
    this.showBtmNav();
    if (this.location.path() == '') {
      this.globeService.login();
    }


  }

  checkMainContentRendering()
  {
    //console.log('checkMainContentRendering');
     //Wait until burger loading is completed before rendering other components as 
    //they are dependent on burger data
    this.datasharing.burgerLoading.subscribe(data => {
      if(data)
      {
        this.renderMainContent = true;
      }
    });
  }


  // BOTTOM NAV STARTS HERE
  public scrlDrctn: any = "";
  showScrlTop: boolean = false;
  // public headerTstn: boolean = false;

  // FIND SCROLL DIRECTION STARTS HERE
  getScrlDirection() {
    var lastScrollTop = 0;
    window.addEventListener("scroll", () => {

      var st = window.pageYOffset || document.documentElement.scrollTop;

      // SCROLLED PERCENTAGE STARTS HERE
      var winheight = window.innerHeight || (document.documentElement || document.body).clientHeight
      var docheight = this.getDocHeight();
      var trackLength = docheight - winheight;
      var hdrHt = this.headerComp?.getHdHt() + 20;
      var pctScrolled = Math.floor(st / trackLength * 100) // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)
      this.showScrlTop = pctScrolled > 25 ? true : false;
      // SCROLLED PERCENTAGE ENDS HERE

      if (st > hdrHt) {
        if (st > lastScrollTop) {
          // downscroll code
          if (this.currentNavigation != 'login') {
            this.document.body.classList.add('hideHdBtm');
            this.scrlDrctn = "down";
            if (pctScrolled > 98) {
              this.document.body.classList.remove('hideHdBtm');
            }
          }
        } else if (st < lastScrollTop) {
          // upscroll code
          if (this.currentNavigation != 'login') {
            this.document.body.classList.remove('hideHdBtm');
            this.scrlDrctn = "up";
          }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      }
    }, false);
  }
  // FIND SCROLL DIRECTION ENDS HERE

  // SCROLLED PERCENTAGE STARTS HERE
  getDocHeight() {
    var D = document;
    return Math.max(
      D.body.scrollHeight, D.documentElement.scrollHeight,
      D.body.offsetHeight, D.documentElement.offsetHeight,
      D.body.clientHeight, D.documentElement.clientHeight
    )
  }
  // SCROLLED PERCENTAGE ENDS HERE

  // SHOW BOTTOM NAVIGATION FUNCTION STARTS HERE
  showBtmNav() {
    let _this = this;
    if (window.innerWidth < 992) {
      _this.service.isShowBtmNav = true;
    } else {
      _this.service.isShowBtmNav = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onWresize() {
    if (window.innerWidth < 992) {
      this.service.isShowBtmNav = true;
    } else {
      this.service.isShowBtmNav = false;
    }
  }  

  reset() {
      this.idle.watch();
      this.idleState = 'Started.';
      this.timedOut = false;
  }

  sessionexpired() {
    if(this.sessionList.Username != null)
    {
      console.log('call logout');
      this.globeService.logout();
    }
  }

  startWatching() {
    //const lastPing = localStorage.getItem('lastPing');
    // if (lastPing) {
    //   //this.lastPing = new Date(lastPing);
    // }

    this.idle.setIdle(this.idleSessionStart ); // Set idle time to 60 seconds
    this.idle.setTimeout(this.sessionTimeout ); // Set timeout to 840 seconds
    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      console.log("idle end");
      this.reset();
    });
    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      console.log('Inside idle timeout');

      this.sessionexpired();
    });
    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
     console.log("idle start");});

     this.idle.setInterrupts([
             new EventTargetInterruptSource(
                this.elementRef.nativeElement, 'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll')]
               
              );
    this.keepalive.interval(15);
    // this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
    this.reset();
  }


}
